import { AmmTxFeeMapping } from '@teddyswap/cardano-dex-sdk';

export const ammTxFeeMapping: AmmTxFeeMapping = {
  swapOrder: 1000000n,
  depositOrder: 1000000n,
  redeemOrder: 1000000n,
  swapExecution: 1000000n,
  depositExecution: 1000000n,
  redeemExecution: 1000000n,
};
